export enum QuestionModule {
  Common = 'common',
  Business = 'business',
  SDGs = 'sdgs',
}
